import { connect } from 'react-redux';

import Home from './Home';

const mapStateToProps = ({ auth, locale }) => ({
  jwt: auth.jwt || '',
});

export default connect(mapStateToProps)(Home);
